// Module
var code = "<react-component name=\"AppointmentTypesList\"></react-component>\n";
// Exports
module.exports = code;